export const MY_CAR_FORUM_IMAGE_WIDTH = 195;
export const MY_CAR_FORUM_IMAGE_HEIGHT = 30;

export const MY_CAR_FORUM_IMAGE_LINK = 'https://i.i-sgcm.com/new_cars/mycarforumlogo.svg';
export const MY_CAR_FORUM_INDEX_LINK = 'https://www.mycarforum.com/index.php';
export const MY_CAR_FORUM_HOME_LINK = 'https://www.mycarforum.com';
